import { useMemo, useState, useRef } from 'react';
import {
  Box,
  Card,
  Container,
  Grid,
  IconButton,
  Stack,
  TextField,
  Tooltip
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import Tables from '../../../components/Tables';
import PageTitleWrapper from '../../../components/PageTitleWrapper';
import PageHeader from '../../../components/pageHeader';
import NoDataFound from '../../../components/NoDataFound';
import CommonDialog from '../../../utils/commenModel';
import { PageIcons } from 'src/assets/icons';
import AddStaff, { StaffFormValues } from './components/addstaff';
import { useTranslation } from 'react-i18next';
import { render } from 'react-dom';
import PageButton from 'src/components/PageButton';
import AppChip from 'src/components/pageStatusLable/AppChip';
import { useDeleteAdminStaffMutation, useGetAdminStaffListQuery, useUpdateAdminStaffStatusMutation } from 'src/reduxServer/services/adminStaff';
import Loader from 'src/components/Loader';
import { showToast } from 'src/utils/toastfy';
import { useNavigate } from 'react-router-dom';

const AdminStaff = () => {
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [search, setSearch] = useState('');
  const [openDelete, setOpenDelete] = useState(false);
  const [openAdd, setOpenAdd] = useState(false);
  const [selectedRow, setSelectedRow] = useState<StaffFormValues | null>(null);
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  const [staffList, setStaffList] = useState<StaffFormValues[]>([]);
  const statusLawyerRef = useRef<any>(null);
  const [openStatusDialog, setOpenStatusDialog] = useState(false);
  const [statusOpen,setStatusOpen] = useState(false)
  const navigate = useNavigate()

  const { data: staffListData, isLoading } = useGetAdminStaffListQuery()
  const [deleteStaffData] = useDeleteAdminStaffMutation()
  const [updateStatus] = useUpdateAdminStaffStatusMutation();


  console.log("AdminStaffData>>>", staffListData?.data)
  /* -------------------- FILTER -------------------- */
  const filteredData = useMemo(() => {
    return staffList.filter(
      (item) =>
        `${item.first_name} ${item.last_name}`
          .toLowerCase()
          .includes(search.toLowerCase()) ||
        item.email.toLowerCase().includes(search.toLowerCase())
    );
  }, [search, staffList]);


  const consultationsData = useMemo(() => {
    if (!staffListData?.data) return [];

    return staffListData.data.map((item) => ({
      id: item.id,
      first_name: item.first_name,
      last_name: item.last_name,
      full_name: `${item.first_name} ${item.last_name}`,
      email: item.email,
      mobile: item.mobile,
      gender: item.gender,
      ID_type: item.ID_type,
      ID_num:item?.ID_num,
      is_active: item.is_active,
      dob:item?.dob

    }));
  }, [staffListData?.data]);

  /* -------------------- HANDLERS -------------------- */
  const handleDeleteConfirm = () => {
    setStaffList((prev) => prev.filter((s) => s.id !== selectedRow?.id));
    setOpenDelete(false);
  };

  const handleNaviget = (row: any) => {
    navigate(`/Page/staff-datail/${row.id}`);
  };

    const confirmDelete = async () => {
      setLoading(true);
      try {
        await deleteStaffData(selectedRow.id).unwrap();
        showToast("success", "Consultation deleted successfully");
        setLoading(false);
  
      } catch (error: any) {
        showToast("error", error?.data?.msg || "Delete failed");
        setLoading(false);
  
      } finally {
        setOpenDelete(false);
      }
    };


const handleStatusClick = async (row: any) => {
  statusLawyerRef.current = row
  setStatusOpen(true)
 
};

const onUpdateStatus =async()=>{
  setLoading(true)
 try {
    await updateStatus({
      id: statusLawyerRef.current.id,
      is_active: !statusLawyerRef.current.is_active

    }).unwrap();
    
          showToast('success', ` Status Updated successfully`);
          setStatusOpen(false)
  setLoading(false)


  } catch (error) {
    console.error("Failed to update status", error);
  }
}
    
  /* -------------------- TABLE COLUMNS -------------------- */
  const columns = [
    {
      key: 'full_name',
      label: t('Name'),
      render: (row: any) => (
           <span
          onClick={() => handleNaviget(row)}
          style={{
            color: "#1976d2",
            cursor: "pointer",
          }}
        >
          {row.full_name}
        </span>
      )
    },
    {
      key: 'email',
      label: t('Email')
    },
    {
      key: 'mobile',
      label: t('Mobile')
    },
    {
      key: 'is_active',
      label: t('Status'),
      render: (row: any) => (
        <PageButton variant="text" onClick={()=>handleStatusClick(row)} >
          <AppChip
            label={row.is_active ? t('Active') : t('Inactive')}
            variantType={row.is_active ? 'success' : 'error'}
          />
        </PageButton>
      )
    },
    {
      key: 'action',
      label: t('Actions'),
      render: (row: any) => (
        <>
          <Tooltip title={t('Edit')}>
            <IconButton
              onClick={() => {
                setSelectedRow(row);
                setOpenAdd(true);
              }}
            >
              <EditIcon />
            </IconButton>
          </Tooltip>

          <Tooltip title={t('Delete')}>
            <IconButton
              color="error"
              onClick={() => {
                setSelectedRow(row);
                setOpenDelete(true);
              }}
            >
              <DeleteIcon />
            </IconButton>
          </Tooltip>
        </>
      )
    }
  ];

  if(isLoading){
    return <Loader/>
  }

  return (
    <>
      <PageTitleWrapper>
        <Container maxWidth="xl">
          <Grid container alignItems="center" spacing={2}>
            <Grid item xs={12} md={4}>
              <PageHeader title={t('Admin Staff')} />
            </Grid>

            <Grid item xs={12} md={8}>
              <Stack
                direction={{ xs: 'column', md: 'row' }}
                spacing={2}
                justifyContent="flex-end"
              >
                <PageHeader
                  title=""
                  buttonLabel={t('Add Staff')}
                  startIcon={<PageIcons.Add />}
                  onButtonClick={() => {
                    setSelectedRow(null);
                    setOpenAdd(true);
                  }}
                />
              </Stack>
            </Grid>
          </Grid>
        </Container>
      </PageTitleWrapper>

      <Container maxWidth="xl">
        <Card sx={{ minHeight: 500 }}>
          {consultationsData.length === 0 ? (
            <Box display="flex" justifyContent="center" p={5}>
              <NoDataFound />
            </Box>
          ) : (
            <Tables
              columns={columns}
              data={consultationsData}
              total={consultationsData?.length}
              page={page}
              limit={limit}
              onPageChange={(_, newPage) => setPage(newPage)}
              onLimitChange={(e) => {
                setLimit(Number(e.target.value));
                setPage(0);
              }}
            />

          )}
        </Card>
      </Container>

      {/* DELETE DIALOG */}
      <CommonDialog
        open={openDelete}
        onClose={() => setOpenDelete(false)}
        title={t('deleteConform')}
        content={`${selectedRow?.first_name} ${selectedRow?.last_name}`}
        onConfirm={confirmDelete}
        confirmText={t('Confirm')}
        cancelText={t('Cancel')}
        loading={loading}
      />

            <CommonDialog
        open={statusOpen}
        onClose={() => setStatusOpen(false)}
        title={t('Want to Update Status')}
        content={""}
        onConfirm={onUpdateStatus}
        confirmText={t('Confirm')}
        cancelText={t('Cancel')}
        loading={loading}
      />

      {/* ADD / EDIT DIALOG */}
      <AddStaff
        open={openAdd}
        onCancel={() => setOpenAdd(false)}
        updateData={selectedRow}
      />
    </>
  );
};

export default AdminStaff;
